import { useEffect, useState } from "react";
import {
  useGetDownloadPdfUrl,
  useGetRecipeGenericProcessForCompany
} from "../../../../api/recipe-specific-generic-process";
import { useGetRecipeImpactDetailsByRecipeId } from "../../../../api/recipeImpactDetails";
import { useGetRecipeResultsByRecipeId } from "../../../../api/recipeResults";
import {
  useCalculateRecipe,
  useDeleteRecipeIngredient,
  useDeleteRecipeVariant,
  useGetRecipeById,
  useUpdateIngredientPercentage
} from "../../../../api/recipeSimulator";
import { useGetStaticRecipeIngredientData } from "../../../../api/static-data";

export const useManageRecipeVariantData = (recipeId: any, tenantId: string) => {
  const {
    data: recipeData,
    refetch: recipeDataRefetch,
    isLoading: isRecipeDataLoading
  } = useGetRecipeById(recipeId);

  const { data: genericProcess } = useGetRecipeGenericProcessForCompany(tenantId);
  const { mutate: getPdfUrl, isLoading: isGetDocumentLoading } = useGetDownloadPdfUrl();

  const { data: staticRecipeIngredients, isLoading: isLoadingStaticRecipeIngredients } =
    useGetStaticRecipeIngredientData();
  const staticRecipeIngredientList = staticRecipeIngredients ?? [];

  const { mutate: calculateRecipe, isLoading: isCalculateRecipeLoading } = useCalculateRecipe();
  const { mutate: deleteRecipeIngredient, isLoading: isDeleteRecipeIngredientLoading } =
    useDeleteRecipeIngredient();
  const { mutate: deleteRecipeVariant, isLoading: isDeleteRecipeVariant } =
    useDeleteRecipeVariant();
  const { mutate: updateIngredientPercentage } = useUpdateIngredientPercentage();

  const { data: impactDetails } = useGetRecipeImpactDetailsByRecipeId(recipeId);
  const [productSize, setProductSize] = useState<number>(impactDetails?.productionSize ?? 1000);

  const {
    data: recipeResults,
    isFetching,
    refetch: refetchRecipeResults
  } = useGetRecipeResultsByRecipeId(recipeId ?? undefined);

  useEffect(() => {
    setProductSize(impactDetails?.productionSize ?? 1000);
  }, [impactDetails?.productionSize]);

  const isLoading =
    isRecipeDataLoading ||
    isLoadingStaticRecipeIngredients ||
    isDeleteRecipeIngredientLoading ||
    isCalculateRecipeLoading ||
    isDeleteRecipeVariant ||
    isFetching ||
    isGetDocumentLoading;

  return {
    recipeData,
    recipeDataRefetch,
    genericProcess,
    staticRecipeIngredientList,
    isLoadingStaticRecipeIngredients,
    isRecipeDataLoading,
    isFetching,
    calculateRecipe,
    deleteRecipeIngredient,
    deleteRecipeVariant,
    updateIngredientPercentage,
    getPdfUrl,
    impactDetails,
    productSize,
    setProductSize,
    recipeResults,
    refetchRecipeResults,
    isLoading
  };
};
